export default __webpack_public_path__ + "static/media/img_120.20aec743.jpg";